// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file order_stats.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file order_stats.proto.
 */
export const file_order_stats: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message cryptotrader.OrderStats
 */
export type OrderStats = Message<"cryptotrader.OrderStats"> & {
  /**
   * @generated from field: google.protobuf.Timestamp from = 1;
   */
  from?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to = 2;
   */
  to?: Timestamp | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsHealth health = 3;
   */
  health?: OrderStatsHealth | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsTrading trading = 4;
   */
  trading?: OrderStatsTrading | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsCapital capital = 5;
   */
  capital?: OrderStatsCapital | undefined;

  /**
   * @generated from field: repeated cryptotrader.OrderStatsGroup groups = 6;
   */
  groups: OrderStatsGroup[];

  /**
   * @generated from field: repeated cryptotrader.OrderStatsReason skip_reasons = 7;
   */
  skipReasons: OrderStatsReason[];

  /**
   * @generated from field: repeated cryptotrader.OrderStatsReason error_reasons = 8;
   */
  errorReasons: OrderStatsReason[];
};

/**
 * Describes the message cryptotrader.OrderStats.
 * Use `create(OrderStatsSchema)` to create a new message.
 */
export const OrderStatsSchema: GenMessage<OrderStats> = /*@__PURE__*/
  messageDesc(file_order_stats, 0);

/**
 * @generated from message cryptotrader.OrderStatsHealth
 */
export type OrderStatsHealth = Message<"cryptotrader.OrderStatsHealth"> & {
  /**
   * @generated from field: cryptotrader.OrderStatsCounts counts = 1;
   */
  counts?: OrderStatsCounts | undefined;

  /**
   * @generated from field: optional double fill_rate = 2;
   */
  fillRate?: number | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsVolume volume_quote = 3;
   */
  volumeQuote?: OrderStatsVolume | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsSlippage slippage = 4;
   */
  slippage?: OrderStatsSlippage | undefined;

  /**
   * @generated from field: int64 price_estimated = 5;
   */
  priceEstimated: bigint;
};

/**
 * Describes the message cryptotrader.OrderStatsHealth.
 * Use `create(OrderStatsHealthSchema)` to create a new message.
 */
export const OrderStatsHealthSchema: GenMessage<OrderStatsHealth> = /*@__PURE__*/
  messageDesc(file_order_stats, 1);

/**
 * @generated from message cryptotrader.OrderStatsCounts
 */
export type OrderStatsCounts = Message<"cryptotrader.OrderStatsCounts"> & {
  /**
   * @generated from field: int64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: int64 done = 2;
   */
  done: bigint;

  /**
   * @generated from field: int64 pending = 3;
   */
  pending: bigint;

  /**
   * @generated from field: int64 error = 4;
   */
  error: bigint;

  /**
   * @generated from field: int64 skipped = 5;
   */
  skipped: bigint;

  /**
   * @generated from field: int64 canceled = 6;
   */
  canceled: bigint;
};

/**
 * Describes the message cryptotrader.OrderStatsCounts.
 * Use `create(OrderStatsCountsSchema)` to create a new message.
 */
export const OrderStatsCountsSchema: GenMessage<OrderStatsCounts> = /*@__PURE__*/
  messageDesc(file_order_stats, 2);

/**
 * @generated from message cryptotrader.OrderStatsVolume
 */
export type OrderStatsVolume = Message<"cryptotrader.OrderStatsVolume"> & {
  /**
   * @generated from field: string buy = 1;
   */
  buy: string;

  /**
   * @generated from field: string sell = 2;
   */
  sell: string;
};

/**
 * Describes the message cryptotrader.OrderStatsVolume.
 * Use `create(OrderStatsVolumeSchema)` to create a new message.
 */
export const OrderStatsVolumeSchema: GenMessage<OrderStatsVolume> = /*@__PURE__*/
  messageDesc(file_order_stats, 3);

/**
 * @generated from message cryptotrader.OrderStatsSlippage
 */
export type OrderStatsSlippage = Message<"cryptotrader.OrderStatsSlippage"> & {
  /**
   * @generated from field: int64 count = 1;
   */
  count: bigint;

  /**
   * @generated from field: optional double mean_bps = 2;
   */
  meanBps?: number | undefined;

  /**
   * @generated from field: optional double worst_bps = 3;
   */
  worstBps?: number | undefined;
};

/**
 * Describes the message cryptotrader.OrderStatsSlippage.
 * Use `create(OrderStatsSlippageSchema)` to create a new message.
 */
export const OrderStatsSlippageSchema: GenMessage<OrderStatsSlippage> = /*@__PURE__*/
  messageDesc(file_order_stats, 4);

/**
 * @generated from message cryptotrader.OrderStatsTrading
 */
export type OrderStatsTrading = Message<"cryptotrader.OrderStatsTrading"> & {
  /**
   * @generated from field: int64 trades = 1;
   */
  trades: bigint;

  /**
   * @generated from field: string realized_pnl = 2;
   */
  realizedPnl: string;

  /**
   * @generated from field: double win_rate = 3;
   */
  winRate: number;

  /**
   * @generated from field: optional double profit_factor = 4;
   */
  profitFactor?: number | undefined;

  /**
   * @generated from field: optional double avg_pnl_pct = 5;
   */
  avgPnlPct?: number | undefined;

  /**
   * @generated from field: string best_trade_pnl = 6;
   */
  bestTradePnl: string;

  /**
   * @generated from field: string worst_trade_pnl = 7;
   */
  worstTradePnl: string;

  /**
   * @generated from field: optional double avg_duration_secs = 8;
   */
  avgDurationSecs?: number | undefined;

  /**
   * @generated from field: string orphan_exit_volume = 9;
   */
  orphanExitVolume: string;
};

/**
 * Describes the message cryptotrader.OrderStatsTrading.
 * Use `create(OrderStatsTradingSchema)` to create a new message.
 */
export const OrderStatsTradingSchema: GenMessage<OrderStatsTrading> = /*@__PURE__*/
  messageDesc(file_order_stats, 5);

/**
 * @generated from message cryptotrader.OrderStatsCapital
 */
export type OrderStatsCapital = Message<"cryptotrader.OrderStatsCapital"> & {
  /**
   * @generated from field: double capital_years = 1;
   */
  capitalYears: number;

  /**
   * @generated from field: optional double air = 2;
   */
  air?: number | undefined;

  /**
   * @generated from field: string max_deployed = 3;
   */
  maxDeployed: string;

  /**
   * @generated from field: repeated cryptotrader.OrderStatsOpenPos open = 4;
   */
  open: OrderStatsOpenPos[];
};

/**
 * Describes the message cryptotrader.OrderStatsCapital.
 * Use `create(OrderStatsCapitalSchema)` to create a new message.
 */
export const OrderStatsCapitalSchema: GenMessage<OrderStatsCapital> = /*@__PURE__*/
  messageDesc(file_order_stats, 6);

/**
 * @generated from message cryptotrader.OrderStatsOpenPos
 */
export type OrderStatsOpenPos = Message<"cryptotrader.OrderStatsOpenPos"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: string side = 3;
   */
  side: string;

  /**
   * @generated from field: string qty = 4;
   */
  qty: string;

  /**
   * @generated from field: string entry_notional = 5;
   */
  entryNotional: string;

  /**
   * @generated from field: string avg_entry_price = 6;
   */
  avgEntryPrice: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_opened_at = 7;
   */
  firstOpenedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.OrderStatsOpenPos.
 * Use `create(OrderStatsOpenPosSchema)` to create a new message.
 */
export const OrderStatsOpenPosSchema: GenMessage<OrderStatsOpenPos> = /*@__PURE__*/
  messageDesc(file_order_stats, 7);

/**
 * @generated from message cryptotrader.OrderStatsGroup
 */
export type OrderStatsGroup = Message<"cryptotrader.OrderStatsGroup"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: int64 trades = 2;
   */
  trades: bigint;

  /**
   * @generated from field: string realized_pnl = 3;
   */
  realizedPnl: string;

  /**
   * @generated from field: double win_rate = 4;
   */
  winRate: number;

  /**
   * @generated from field: optional double profit_factor = 5;
   */
  profitFactor?: number | undefined;

  /**
   * @generated from field: optional double avg_pnl_pct = 6;
   */
  avgPnlPct?: number | undefined;

  /**
   * @generated from field: optional double avg_duration_secs = 7;
   */
  avgDurationSecs?: number | undefined;

  /**
   * @generated from field: double capital_years = 8;
   */
  capitalYears: number;

  /**
   * @generated from field: optional double air = 9;
   */
  air?: number | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsVolume volume_quote = 10;
   */
  volumeQuote?: OrderStatsVolume | undefined;

  /**
   * @generated from field: string orphan_exit_volume = 11;
   */
  orphanExitVolume: string;

  /**
   * @generated from field: cryptotrader.OrderStatsCounts orders = 12;
   */
  orders?: OrderStatsCounts | undefined;

  /**
   * @generated from field: cryptotrader.OrderStatsSlippage slippage = 13;
   */
  slippage?: OrderStatsSlippage | undefined;

  /**
   * @generated from field: repeated cryptotrader.OrderStatsOpenPos open = 14;
   */
  open: OrderStatsOpenPos[];
};

/**
 * Describes the message cryptotrader.OrderStatsGroup.
 * Use `create(OrderStatsGroupSchema)` to create a new message.
 */
export const OrderStatsGroupSchema: GenMessage<OrderStatsGroup> = /*@__PURE__*/
  messageDesc(file_order_stats, 8);

/**
 * @generated from message cryptotrader.OrderStatsReason
 */
export type OrderStatsReason = Message<"cryptotrader.OrderStatsReason"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint;
};

/**
 * Describes the message cryptotrader.OrderStatsReason.
 * Use `create(OrderStatsReasonSchema)` to create a new message.
 */
export const OrderStatsReasonSchema: GenMessage<OrderStatsReason> = /*@__PURE__*/
  messageDesc(file_order_stats, 9);

